/**
 * Hello Ava
 *
 * Copyright © 2016-2017 Helloava, Inc. All rights reserved.
 *
 * Filename: NotFound
 *
 * Created by robertcaslin.
 */

import React, { Component } from 'react';
import styled from 'styled-components';

class NotFound extends Component {

    render() {
        let Content = styled.div`
            display:flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 15rem 0;
            width:100%;
            height: 100%;
            align-items:center;
            justify-content:center;
        `;
        return (
            <Content>
                <h1>404 - Page Not Found</h1>
                <p>I'm sorry, the page you were looking for cannot be found!</p>
            </Content>
        )
    }
}
export default NotFound;


// WEBPACK FOOTER //
// ./src/views/notfound/NotFound.js